import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_CLASSROOMTYPE,
  GET_CLASSROOMTYPES,
  ADD_CLASSROOMTYPE,
  UPDATE_CLASSROOMTYPE,
  DELETE_CLASSROOMTYPE
} from '@/queries/modules/class-room/classRoomType';

export async function getClassRoomTypes(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOMTYPES,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassRoomTypes', data.getClassRoomTypes);
      context.commit('setSuccess', null);
      return data.getClassRoomTypes
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassRoomType(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOMTYPE,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setClassRoomType', data.getClassRoomType);
      context.commit('setSuccess', null);
      return data.getClassRoomType
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addClassRoomType(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_CLASSROOMTYPE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const classRoomTypes = [...context.state.classRoomTypes];
      classRoomTypes.push(data.addClassRoomType);
      context.commit('setClassRoomTypes', classRoomTypes);
      context.commit('setSuccess', newItemSuccess(data.addClassRoomType.nameLocal));

      return data.addClassRoomType
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateClassRoomType(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_CLASSROOMTYPE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.classRoomTypes.findIndex(item => item.id === data.updateClassRoomType.id);
      const classRoomTypes = [
        ...context.state.classRoomTypes.slice(0, index),
        data.updateClassRoomType,
        ...context.state.classRoomTypes.slice(index + 1)
      ];
      context.commit('setClassRoomTypes', classRoomTypes);
      context.commit('setSuccess', updateItemSuccess(data.updateClassRoomType.nameLocal));

      return data.updateClassRoomType
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteClassRoomType(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_CLASSROOMTYPE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.classRoomTypes.findIndex(item => item.id === data.deleteClassRoomType.id);
      const classRoomTypes = [
        ...context.state.classRoomTypes.slice(0, index),
        ...context.state.classRoomTypes.slice(index + 1)
      ];
      context.commit('setClassRoomTypes', classRoomTypes);
      context.commit('setSuccess', deleteItemSuccess(data.deleteClassRoomType.nameLocal));

      return data.deleteClassRoomType
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

